


















import { Component, Mixins } from "vue-property-decorator";

// Mixins
import ImportInjectorMixin from "@/mixins/importInjectorMixin";

@Component({
  components: {
    "import-step-vessel": () =>
      import("@/components/app/admin/imports/importStepVessel.vue")
  }
})
export default class ImportSteps extends Mixins(ImportInjectorMixin) {}
